import Alpine from 'alpinejs'

Alpine.store('Gallery', {
  isOpen: false,

  open() {
    this.isOpen = true
  },

  close() {
    this.isOpen = false
  },
})
